export default __webpack_public_path__ + "static/media/ts1.161918c5.png";